import { CHAIN_ID, Context } from '@derivation-tech/context';
import { DefaultEthGasEstimator, txPlugin } from '@derivation-tech/tx-plugin';
import { JsonRpcProvider, JsonRpcSigner } from '@ethersproject/providers';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { perpPlugin } from '@synfutures/sdks-perp';
import { perpDataSourcePlugin } from '@synfutures/sdks-perp-datasource';
import { perpLaunchpadPlugin } from '@synfutures/sdks-perp-launchpad';
import { perpLaunchpadDataSourcePlugin } from '@synfutures/sdks-perp-launchpad-datasource';

import VAULT_CONFIG from '@/configs/vault.json';

import { DAPP_CHAIN_CONFIGS } from '@/constants/chain';

import { AppState } from '../store';

export const initSDKContext = createAsyncThunk(
  'web3/initSDKContext',

  async (
    { chainId, provider }: { chainId: number; provider: JsonRpcProvider },
    { getState },
  ): Promise<Context | undefined> => {
    const {
      web3: { chainSDK },
    } = getState() as AppState;
    try {
      // dispatch(setAppProvider({ chainId, provider }));
      if (chainSDK[chainId]) {
        return;
      }
      const chainConfig = DAPP_CHAIN_CONFIGS[chainId];
      const chainVaultConfig = VAULT_CONFIG.chainConfig[chainId as unknown as keyof typeof VAULT_CONFIG.chainConfig];

      const ctx = new Context(chainId)
        .use(perpPlugin({ inverse: true }))
        .use(txPlugin({ gasLimitMultiple: 1.7, gasEstimator: new DefaultEthGasEstimator() }))
        .use(perpLaunchpadPlugin()) // vaultPlugin
        .use(perpLaunchpadDataSourcePlugin(chainVaultConfig?.graphAddr || '')) // vaultDataSourcePlugin
        .use(
          perpDataSourcePlugin({ endpoint: chainConfig.subgraph, inverse: true }), // dataSourcePlugin
        );

      ctx.setProvider(provider);
      await ctx.init();

      return ctx;

      return undefined;
    } catch (e) {
      console.error('init sdk error', e);
    }
  },
);

export const setAppProvider = createAsyncThunk(
  'web3/setAppProvider',

  (
    { chainId, provider }: { chainId: CHAIN_ID; provider: JsonRpcProvider },
    { getState },
  ): JsonRpcProvider | undefined => {
    const {
      web3: { chainAppProvider },
    } = getState() as AppState;

    if (chainAppProvider[chainId]) {
      return;
    }
    return provider;
  },
);

export const setAppSigner = createAction<{ chainId: number; signer: JsonRpcSigner | undefined }>('web3/setAppSigner');
